import { Component, Input } from '@angular/core';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from 'src/app/core/services/http.service';

@Component({
  selector: 'app-deal-approve-button',
  templateUrl: './deal-approve-button.component.html',
  styleUrls: ['./deal-approve-button.component.scss']
})
export class DealApproveButtonComponent {
  @Input('lob') lob: string;
  @Input('disabled') disabled: boolean = false;
  ruleId: string;
  submitting: boolean = false;
  showPopup:boolean=false

  remark: string;

  constructor(private http: HttpService, private activatedRoute: ActivatedRoute, private snackbarService: SnackbarService) { };

  ngOnInit() {
      this.activatedRoute.params.subscribe((params: any) => {
          this.ruleId = params['id'];
      });
  }

  approve() {
      this.submitting = true;
      const url = `/services/api/v1/special-deals/approved_rules`;
      const data = {
          'lob': this.lob,
          'rule_id': this.ruleId,
      };

      this.http.post(url, data).subscribe((res: any) => {
          this.snackbarService.openSnackbar('Approved');
          window.location.href = "/rules/overview/" + this.lob;
          this.submitting = false;
      },
          err => this.submitting = false
      );
  }

  reject() {
      this.submitting = true;
      const url = `/services/api/v1/special-deals/reject_rules`;
      const data = {
          'lob': this.lob,
          'rule_id': this.ruleId,
          'remark': this.remark,
      };

      this.http.post(url, data).subscribe((res: any) => {
          this.snackbarService.openSnackbar('Rejected');
          window.location.href = "/rules/overview/" + this.lob;
          this.submitting = false;
      },
          err => this.submitting = false
      );
  }
  openPopup() {
    this.showPopup = true;
  }
  closePopup2() {
    this.showPopup = false;
  }

}
